import '../CsvJsonInfoPages.scss';


function FuturePrices() {



    return (
        <div className='csv-json-info-pages-container'>
            <h1>Future Values - Age / Mileage Calculation Rules</h1>
            <p>Calculation for mileage and/or age adjustments applied to the new and used Future Valuations files CAP Monitor.
                <b>Formula: Rounding Routine</b>
                When a valuation is produced, CAP then applies custom monitor rounding routines.<br />
                This is denoted by the use of Round25(v), the defn of which is<br /><br />

                fn Round25(x)<br />
                {`{

                if x - ((x div 25) * 25) > 12 then

                 x := ((x div 25) + 1) * 25

                else

                x := (x div 25) * 25



                return x 

                }`}`

                <br />
                The Trunc(x) function ignores all fractional part of a value, and returns the largest integer which is not greater than x.<br />
                Ie. Trunc(6.666) = 6, Trunc(5.23) = 5
            </p>

            <b>Formula: Valuing Custom Mileages</b>
            <p>V1 = Round25(V1)<br />
                V2 = Round25(V2)<br />
                V = Round25(V1 - (Trunc((V1 - V2) / (M2 - M1)) * (M - M1)))<br /><br />

                where V1 = Value at lower mileage,<br />
                V2 = Value at higher mileage<br />
                M1 = lower mileage<br />
                M2 = higher mileage<br />
                M = custom mileage
            </p>

            <b>Formula: Valuing Custom Periods</b>
            <p>V1 = Round25(V1)<br />
                V2 = Round25(V2)<br />
                V = Round25(V1 - (Trunc((V1 - V2) / (P2 - P1)) * (P - P1)))<br /><br />

                where V1 = Value at earlier period<br />
                V2 = Value at later period<br />
                P1 = period 1 (expressed in months)<br />
                P2 = period 2 (expressed in months)<br />
                P = custom period
            </p>

            <b>Example 1 - Derive a future residual valuation for a vehicle which lies between two published mileages, for a given period.</b>
            <p>This example uses CAP ID: 20746 (April 2002)<br />
                To derive a valuation V for a vehicle at a mileage M, which lies between two published mileages M1 (valued at V1)
                and M2 (valued at V2), simply calculate a linear interpolation between M1 and M2, and use this to proportionally derive V according to M.<br /><br />

                At 12 months, a vehicle with 10000 miles (M1) is valued at 8425 (V1).<br />
                At 12 months, the same vehicle with 20000 miles (M2) is valued at 7950 (V2).<br />
                We want to find the valuation (V) of the vehicle at 13000 miles (M).<br /><br />

                Mileages must be specified as whole integer and expressed in terms of 1000.<br />
                Both V1 and V2 are rounded to the nearest 25 before input into the function.<br /><br />

                V1 = Round25(8425) = 8425<br />
                V2 = Round25(7950) = 7950<br /><br />

                V = Round25(V1 - (Trunc((V1 - V2) / (M2 - M1)) * (M - M1)))<br />
                V = Round25(8425 - (Trunc((8425 - 7950) / (20 - 10)) * (13 - 10)))<br />
                V = Round25(8425 - (Trunc(475 / 10) * 3))<br />
                V = Round25(8284)<br /><br />

                V = 8275<br /><br />

                So at 13000, at 12 months, the vehicle is valued at 8275.
            </p>

            <b>Example 2 - Derive a future residual valuation for a vehicle which lies between two published periods, for a given mileage.</b>
            <p>This example uses CAP ID: 21470 (April 2002)<br /><br />

                At 12 months (P1) a vehicle with 10000 miles is valued at 10100 (V1).<br />
                At 18 months (P2) the same vehicle with 10000 miles is valued at 9400 (V2).<br />
                We want to find the value (V) of the vehicle at 14 months (P).<br /><br />

                Both V1 and V2 are rounded to the nearest 25 before input into the function.<br /><br />

                V1 = Round25(10100) = 10100<br />
                V2 = Round25(9400) = 9400<br />

                V = Round25(V1 - (Trunc((V1 - V2) / (P2 - P1)) * (P - P1)))<br />
                V = Round25(10100 - (Trunc((10100 - 9400) / (18 - 12)) * (14 - 12)))<br />
                V = Round25(10100 - (116 * 2))<br />
                V = Round25(9868)<br /><br />

                V = 9875<br />

                So at 14 months, the vehicle with 10000 miles is valued at 9875.
            </p>

            <b>Example 3 - Derive a future residual valuation for a vehicle which lies between two of the published mileages, but additionally between two of the published periods.</b>
            <p>This example uses CAP ID: 17534 (April 2002)<br /><br />

                At 12 months (P1) a vehicle with 10000 (M1) miles is valued at 27750(V1A) , and at 20000 (M2) is valued at 26150 (V2A).<br />
                At 18 months (P2) the same vehicle with 10000 (M2) miles is valued at 26100(V1B), and at 20000 (M2) is valued at 24600 (V2B).<br />
                We want to calculate the valuation of this vehicle at 16 months (P), after it has done 14000 miles (M).<br /><br />

                First we need to produce valuations for the custom mileage at both 12 months and 18 months.<br /><br />

                --- The value of the vehicle at 12 months, 14000 miles:<br />

                (The procedure for deriving a valuation for a custom mileage is demonstrated in Example 1).<br /><br />

                V1A = Round25(27750) = 27750<br />
                V2A = Round25(26150) = 26150<br />

                V1 = Round25(V1A - (Trunc((V1A - V2A) / (M2 - M1)) * (M - M1)))<br />
                V1 = Round25(27750 - (Trunc((27750 - 26150) / (20 - 10)) * (14 - 10)))<br />
                V1 = Round25(27110) = 27100<br />

                --- The value of the vehicle at 18 months, 14000 miles:<br />
                (The procedure for deriving a valuation for a custom mileage is demonstrated in Example 1).<br /><br />

                V1B = Round25(26100) = 26100<br />
                V2B = Round25(24600) = 24600<br />

                V2 = Round25(V1A - (Trunc((V1A - V2A) / (M2 - M1)) * (M - M1)))<br />
                V2 = Round25(26100 - (Trunc((26100 - 24600) / (20 - 10)) * (14 - 10)))<br />
                V2 = Round25(25500) = 25500<br /><br />

                We now have two valuations for this vehicle with our custom mileage, at 12 and 18 months.<br />
                So for 16 months we know the valuation lies somewhere between these two values.<br />
                We now calculate the valuation for the custom period of 16 months, by finding a proportional value between these two valuations.<br /><br />

                Given that:<br />
                At 12 months (P1) the vehicle with 14000 miles is valued at 27100 (V1)<br />
                At 18 months (P2) the vehicle with 14000 miles is valued at 25500 (V2)<br /><br />

                --- The value of the vehicle at 16 months, 14000 miles...<br />
                (The procedure for deriving a valuation for a custom period is demonstrated in Example 2).<br /><br />

                V = Round25(V1 - (Trunc((V1 - V2) / (P2 - P1)) * (P - P1)))<br />
                V = Round25(27100 - (Trunc((27100 - 25500) / (18 - 12)) * (16 - 12)))<br />
                V = Round25(27100 - (Trunc((27100 - 25500) / (18 - 12)) * (16 - 12)))<br />
                V = Round25(26036) = 26025<br /><br />

                So for 14000 miles, 16 months, the example vehicle has a future residual value of 26025
            </p>

            <b>Seasonal adjustment files
            </b>
            <p>The file "YYYYMMDD.adj" provides the facility to add forecast seasonal variations to Monitor figures. Data is comma delimited.
                The residual values in the Monitor.pr file are used to derive a straight line depreciation between any two given future residual values
                (for a fixed mileage) and the appropriate monthly seasonal factor is used to add or subtract a seasonal percentage from this linear adjustment.
            </p>

            <b>Example file</b>
            <p> 7,-2.2,3.6<br />
                Jan,3.8,2.9,4.4,4.1,4.3,0,0<br />
                Feb,0.6,0.7,1.2,0.9,1.1,0,0<br />
                Mar,2.1,2.3,2.1,2.0,2.1,0,0<br />
                Apr,-0.8,-0.5,-0.2,-0.4,-0.1,0,0<br />
                May,0.0,0.0,-0.2,-0.2,-0.4,0,0<br />
                Jun,0.1,0.2,0.1,0.1,0.0,0,0<br />
                Jul,0.0,0.0,0.3,0.4,0.3,0,0<br />
                Aug,-1.2,-0.9,-0.7,-0.5,-0.5,0,0<br />
                Sep,2.6,2.3,2.2,2.2,2.1,0,0<br />
                Oct,-2.0,-1.7,-1.9,-2.1,-1.5,0,0<br />
                Nov,-2.5,-2.2,-1.8,-1.7,-1.8,0,0<br />
                Dec,-1.2,-1.3,-1.0,-1.4,-1.3,0,0<br /><br />

                Current month<br />
                The first entry “7” refers to the current month (January = 1, February = 2, etc)<br /><br />

                Global Adjustments<br />
                The second entry “-2.2” refers to the +1 month adjustment. For forward quotations (i.e. +1 month is August in this case) then ALL Monitor figures are globally adjusted by the seasonal market movement of -2.2%.<br /><br />

                The third entry “3.6” refers to the +2 month adjustment. For forward quotations (i.e. +2 months is September in this case) then ALL Monitor figures are globally adjusted by the seasonal market movement of +1 month (-2.2%) and then +2 months (+3.6%).<br /><br />

                Seasonal Adjustments<br />
                For each of the months, the associated percentage adjustments are listed. All percentages are in 12 month intervals, so in the example above, January seasonal for 12 months is 3.8%, for 24 months is 2.9% etc
            </p>

            <b>Seasonal Adjustments - example</b>
            <p>From the July Monitor.pr file, a vehicle has a 12 month/10,000 mile price of £8500 and an 18 month/10,000 mile price of £7300. Find the 15 month seasonally adjusted price.<br /><br />

                Non-seasonally adjusted price is<br /><br />

                8500-((8500-7300)/2) = 7900<br /><br />

                From the start month of July, a 15 month forecast would be for October. Since 15 months is between 12 and 24 months, the first October seasonal value of -2% is applied to the value above, resulting in a value of £7750 to the nearest £25.
            </p>

            <b>Option files</b>
            <p>The file "YYYYMMDD.opt" provides the facility to add option values to Monitor values. Data is comma delimited. All options are listed in Manufacturer order, followed by an option name (specifying the vehicle range to be applied to)
                and are priced in 6 month intervals, starting with 12 months. The appropriate pounds value is then added to values at any given future month forecast parameter.
            </p>

            <b>Example</b>
            <p>MANUFACTURER,OPTION,12mth,18mth,24mth,30mth,36mth,42mth,48mth,54mth,60mth,66mth,72mth,78mth,84mth<br /><br />

                ALFA ROMEO,145 AIR CONDITIONING,400,350,300,250,200,150,125,100,100,,,,<br/><br/>

                The first line explains the file layout, so for the option above, the manufacturer is Alfa Romeo and the option is Air Conditioning for the 145 range. Note that all option names include the range of vehicles for which to be applied, to avoid confusion.<br /><br />

                The pounds additional residual values for these options are then listed in six month intervals, so for example, add £400 to the 12 month residual value, £350 to the 18 month residual value etc. </p>

        </div>
    );
}

export default FuturePrices;
